import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoDocumento = () => {
  const [tipoDocumento, setTipoDocumento] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTipoDocumento = async () => {
      try {
        const response = await httpClient.get(
          `/api/documentossisdaf/enumTipoDocumentoGestaoSisAF`,
        );

        const options = response.data.map(
          (documento: { value: number; label: string }) => ({
            value: documento.value.toString(),
            label: documento.label,
          }),
        );
        setTipoDocumento(options);
      } catch (error) {
        console.error('Erro ao buscar Tipos de Documentos', error);
      }
    };

    fetchTipoDocumento();
  }, []);

  return tipoDocumento;
};
